import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import AddProjectComponent from '../../components/AddProjectComponent/AddProjectComponent'

const AddProject = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <AddProjectComponent />
                </div>
            </div>
        </div>
    )
}

export default AddProject
